import { ITags } from "./types";

export const isInsideRadixPopover = (target: EventTarget | null) =>
  target instanceof HTMLElement &&
  !!target.closest("[data-radix-popover-content]");

export function getTagsByIds(
  tags: ITags[],
  ids: string | string[]
): ITags[] {
  if (!Array.isArray(tags) || !ids) return [];

  const idArray = Array.isArray(ids) ? ids : [ids];
  return tags.filter((m) => idArray.includes(m._id));
}
